var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalNumberOfCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_4250)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#BAE0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8032 3.41081L17.0765 4.05063C19.3612 4.3925 20.5409 6.21764 20.199 8.49953L19.2781 14.6568C18.9363 16.9387 17.2746 18.3389 14.9889 17.997L10.7165 17.3572C8.43187 17.0153 7.25215 15.191 7.59308 12.9083L8.51499 6.75099C8.85593 4.4691 10.5251 3.07082 12.8032 3.41081Z",
    stroke: "#0958D9",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3234 8.97754L16.6387 9.59589M11.8281 12.4294L14.4172 12.8011",
    stroke: "#0958D9",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65726 6.12012L5.91115 7.02709C3.71425 7.75004 2.85118 9.74704 3.58348 11.944L5.52725 17.8547C6.25114 20.0431 8.12579 21.1415 10.3134 20.4186L14.4288 19.0671C15.1181 18.8494 15.6925 18.4833 16.111 18.0209",
    stroke: "#0958D9",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNumberOfCourses);
export default __webpack_public_path__ + "static/media/totalNumberOfCourses.7b51bbc7442b0a7961d0533cba5efaf8.svg";
export { ForwardRef as ReactComponent };